import type { Keyframes } from 'styled-components'

const sc =
  <Props>(
    prop: keyof Props,
    cssWhenTrue: string | number | Keyframes,
    cssWhenFalse?: string | number | Keyframes
  ) =>
  (props: Props) =>
    props[prop] ? cssWhenTrue : cssWhenFalse

export default sc
